module.exports = __webpack_public_path__ + "static/tacoma1-72e1d2d5225aaade5542e7fb359236d4.webp";